<template>
  <div id="app">
    <Navigation />
    <Sticky />
    <transition name="fade" mode="out-in">
      <router-view />
    </transition>
    <Footer />
    <Popup />
    <PopupImages />
  </div>
</template>

<script>
import Navigation from './components/layout/Navigation'
import Footer from './components/layout/Footer'
import Popup from './components/shared/Popup'
import PopupImages from './components/shared/PopupImage'
import Sticky from '@/components/shared/Sticky'
export default {
  name: 'LayoutDefault',

  components: {
    Navigation,
    Footer,
    Popup,
    PopupImages,
    Sticky
  },

  mounted() {
    //Disable console.log in production
    // let appState = process.env.NODE_ENV === 'development' ? 'development' : 'production'
    // if (appState === 'production') {
    //   console.log = function () {};
    // }
  },

  metaInfo() {
    return {
      title: 'Veterinary Medicine and Artificial Intelligence',
      titleTemplate: '%s | Aaron Fletcher',
      meta: [
        { charset: 'utf-8' },
        { name: 'viewport', content: 'width=device-width, initial-scale=1' },
        {
          vmid: 'description',
          name: 'description',
          content:
            'Artificial intelligence in veterinary medicine is revolutionizing the industry, especially with the use of natural language processing. Discover the applications and benefits of AI technology in veterinary care.'
        }
      ]
    }
  },

  data() {
    return {}
  }
}
</script>

<style>
.fade-enter-active,
.fade-leave-active {
  transition-duration: 0.3s;
  transition-property: opacity;
  transition-timing-function: ease;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}
</style>
